import React, { useState } from 'react';
import { Send } from 'lucide-react';
import { tt } from '@/utils/localizedStrings';
import { AUDIO_STRINGS } from '@/utils/audioStrings';
import { sendTestPush, pushBrowserName } from '@/utils/prayerPush';

const RESULT_KEY = {
  checking: 'pushTestChecking', sent: 'pushTestSent', dropped: 'pushDropped', wait: 'pushTestWait', error: 'pushError',
};
const BUSY = ['sending', 'checking'];

export const pushText = (key, lang) => tt(AUDIO_STRINGS[key], lang).split('{browser}').join(pushBrowserName());

export const PushTestButton = ({ lang, P, pushParams, onStart }) => {
  const [state, setState] = useState(null);

  const run = async () => {
    if (BUSY.includes(state)) return;
    if (onStart) onStart();
    if (!pushParams) { setState('error'); return; }
    setState('sending');
    try {
      await sendTestPush(pushParams, tt(AUDIO_STRINGS.pushTestTitle, lang), tt(AUDIO_STRINGS.pushTestBody, lang),
        () => setState('checking'));
      setState('sent');
    } catch (e) {
      setState(RESULT_KEY[e.message] ? e.message : 'error');
    }
  };

  const key = RESULT_KEY[state];
  const busy = BUSY.includes(state);
  return (
    <div className="mt-3">
      <button
        type="button"
        onClick={run}
        disabled={busy}
        className="inline-flex items-center gap-2 rounded-lg px-3 py-2"
        style={{ background: 'rgba(16,185,129,0.18)', color: P.primary, fontSize: 13, fontWeight: 600,
          border: '1px solid rgba(52,211,153,0.55)', opacity: busy ? 0.6 : 1, transition: 'opacity 150ms' }}
        data-testid="audio-push-test-btn"
      >
        <Send size={14} />
        {tt(AUDIO_STRINGS.pushTest, lang)}
      </button>
      {key && (
        <div
          className="mt-2"
          style={{ color: ['sent', 'checking'].includes(state) ? P.secondary : '#FCD34D', fontSize: 12.5, lineHeight: 1.6 }}
          data-testid="audio-push-test-result"
        >
          {pushText(key, lang)}
        </div>
      )}
    </div>
  );
};
